import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import Modal from '../../../client/components/Modal';
import { FAVORITE_CLICK_EVENT } from '../../webComponents/FavoriteIcon';
import { HIDE_MODAL_EVENT } from '../../webComponents/Modal/BasicModal';
import Request, { ApiMode } from '../../utils/request';

const CONFIRM_BOOKING_SELECTOR_WRAPPER  = '.p-court-booking-confirmation';
const CONFIRM_BOOKING_SELECTOR_MODAL = '#js-court-booking-confirmation-modal';
const CONFIRM_BOOKING_SELECTOR_CANCEL_BUTTON = '.p-court-booking-confirmation__cancel-booking-btn';
const CONFIRM_BOOKING_SELECTOR_MODAL_CANCEL_BUTTON = '.p-court-booking-confirmation__modal-cancel-btn';
const CONFIRM_BOOKING_SELECTOR_MODAL_ACTION_BUTTON = '.p-court-booking-confirmation__modal-action-btn';
const CONFIRM_BOOKING_SELECTOR_FAVORITE_ICON = 'lta-favorite-icon';
const SELECTOR_TOO_MANY_FAV_MODAL = '#js-too-many-fav-modal';

const SELECTOR_EARLY_CANCELLATION_MODAL = '#js-court-booking-early-cancellation-modal';
const SELECTOR_EARLY_CANCELATTION_BOOKING_BUTTON = '.p-court-booking-confirmation__end-early-booking-button';
const SELECTOR_EARLY_CANCELLATION_MODAL_CANCEL_BUTTON = '.p-court-booking-early-cancellation__modal-cancel-btn';
const SELECTOR_EARLY_CANCELLATION_MODAL_ACTION_BUTTON = '.p-court-booking-early-cancellation__modal-action-btn';

const SELECTOR_SNACKBAR = '.lta-snackbar';
const SELECTOR_ALERT = '.js-alert-dismiss';

const CLICK_EVENT = 'click';
const IS_LOCAL = false;

class CourtBookingConfirmation {
	constructor() {
		this._wrapper = SelectorEngine.findOne(CONFIRM_BOOKING_SELECTOR_WRAPPER );
		if (!this._wrapper) {
			return;
		}
		this.isFavorite = false;
		this.init();
	}

	init() {
		this.confirmationModalElement = SelectorEngine.findOne(CONFIRM_BOOKING_SELECTOR_MODAL, this._wrapper);
		this.confirmationModal = new Modal(this.confirmationModalElement, { backdrop: 'static' });
		this.cancelBookingButton = SelectorEngine.findOne(CONFIRM_BOOKING_SELECTOR_CANCEL_BUTTON, this._wrapper);

		this.modalCancelButton = SelectorEngine.findOne(CONFIRM_BOOKING_SELECTOR_MODAL_CANCEL_BUTTON, this._wrapper);
		this.modalActionButton = SelectorEngine.findOne(CONFIRM_BOOKING_SELECTOR_MODAL_ACTION_BUTTON, this._wrapper);

		this.tooManyFavModal = SelectorEngine.findOne(SELECTOR_TOO_MANY_FAV_MODAL, this._wrapper);
		if(this.tooManyFavModal) {
			this.tooManyFavModal.addEventListener(HIDE_MODAL_EVENT, (event) => {
				this.toggleTooManyFavouriteModal(false);
			});
		}

		this.earlyCancellationModalElement = SelectorEngine.findOne(SELECTOR_EARLY_CANCELLATION_MODAL, this._wrapper);
		this.earlyCancellationModal = new Modal(this.earlyCancellationModalElement, { backdrop: 'static' });
		this.earlyCancellationBookingButton = SelectorEngine.findOne(SELECTOR_EARLY_CANCELATTION_BOOKING_BUTTON, this._wrapper);

		if (this.earlyCancellationModalElement) {
			this.earlyCancellationModalCancelButton = SelectorEngine.findOne(SELECTOR_EARLY_CANCELLATION_MODAL_CANCEL_BUTTON, this.earlyCancellationModalElement);
			this.earlyCancellationModalActionButton = SelectorEngine.findOne(SELECTOR_EARLY_CANCELLATION_MODAL_ACTION_BUTTON, this.earlyCancellationModalElement);
		}

		this.alertWrapper = SelectorEngine.findOne(SELECTOR_SNACKBAR, this._wrapper);
		if(this.alertWrapper) {
			this.dismissAlert = SelectorEngine.findOne(SELECTOR_ALERT, this.alertWrapper);
			EventHandler.on(this.dismissAlert, CLICK_EVENT, this.dismissAlertClickHandler.bind(this));
		}

		EventHandler.on(this.cancelBookingButton, CLICK_EVENT, this.cancelButtonClickHandler.bind(this));
		EventHandler.on(this.modalCancelButton, CLICK_EVENT, () => {
			this.confirmationModal.hide();
		});

		if (this.earlyCancellationBookingButton) {
			EventHandler.on(this.earlyCancellationBookingButton, CLICK_EVENT, this.earlyCancellationButtonClickHandler.bind(this));
		}

		if (this.earlyCancellationModalCancelButton) {
			EventHandler.on(this.earlyCancellationModalCancelButton, CLICK_EVENT, () => {
				this.earlyCancellationModal.hide();
			});
		}

		this.venueId = Manipulator.getDataAttribute(this._wrapper, 'venue-id');
		this.venueName = Manipulator.getDataAttribute(this._wrapper, 'venue-name');
		this.venueImageUrl = Manipulator.getDataAttribute(this._wrapper, 'venue-image-url');
		
		this.removeVenueFavoriteApiUrl = Manipulator.getDataAttribute(this._wrapper, 'favorite-api-remove');

		this.favoriteIcon = SelectorEngine.findOne(CONFIRM_BOOKING_SELECTOR_FAVORITE_ICON, this._wrapper);
		if(this.favoriteIcon) {
			this.isFavorite = this.favoriteIcon.getAttribute('is-favorite') === 'true';			
			this._wrapper.addEventListener(FAVORITE_CLICK_EVENT, (event) => {				
				const favoriteLimitReached = Manipulator.getDataAttribute(this._wrapper, 'favorite-max-count-reached');
				const { isFavorite } = event.detail;
				this.pushDataLayer('favourite_click', isFavorite ? 'added' : 'removed');
				if(isFavorite) {
					if(String(favoriteLimitReached) === 'true') {
						this.toggleTooManyFavouriteModal(true);
						return;
					}
					this.addVenueToFavorites(event);
				} else {
					this.removeVenueFromFavorites(event);
				}
			});
		}
	}

	async addVenueToFavorites(event) {
		const { isFavorite } = event.detail;
		const addVenueFavoriteApiUrl = Manipulator.getDataAttribute(this._wrapper, 'favorite-api-add');
		if (!this.venueId || !this.venueName || !this.venueImageUrl) {
			console.error('Venue details are missing for adding to favorites');
			return;
		}

		const payload = {
			venueId: this.venueId,
			venueName: this.venueName,
			imageUrl: this.venueImageUrl
		};

		try {
			const response = await Request.put(addVenueFavoriteApiUrl, payload, { local: IS_LOCAL });
			if (response?.errors?.errorCode === '00') {
				this.isFavorite = isFavorite;
				this.toggleFavoriteIcon(this.isFavorite);
				this.pushDataLayer('favourite_added', 'added');
				console.log('Venue added to favourites successfully');
			} else {
				console.error('Failed to add to favourites:', response?.errors?.message || 'Unknown error');
			}
		} catch (err) {
			console.error('Failed to add to favourites:', err);
		}
	}

	toggleTooManyFavouriteModal(show = false) {
		if (this.tooManyFavModal) {
			if(show) {
				this.pushDataLayer('favourite_limit_reached_prompt_shown', 'shown');
			}
			this.tooManyFavModal.setAttribute('show', show);
		}
	}

	toggleFavoriteIcon(isFavorite) {
		this.favoriteIcon.setAttribute('is-favorite', isFavorite);
	}

	async removeVenueFromFavorites(event) {
		const { isFavorite } = event.detail;
		const removeVenueFavoriteApiUrl = Manipulator.getDataAttribute(this._wrapper, 'favorite-api-remove');
		if (!this.venueId) {
			console.error('Venue details are missing for removing from favorites');
			return;
		}
		const payload = {
			venueId: this.venueId,
		};
		
		try {
			const response = await Request.delete(removeVenueFavoriteApiUrl, payload, { local: IS_LOCAL });
			if (response?.errors?.errorCode === '00') {
				this.isFavorite = isFavorite;
				this.toggleFavoriteIcon(this.isFavorite);
				this.pushDataLayer('favourite_removed', 'removed');
				console.log('Venue removed from favourites successfully');
			} else {
				console.error('Failed to remove from favourites:', response?.errors?.message || 'Unknown error');
			}
		} catch (err) {
			console.error('Failed to remove from favourites:', err);
		}
	}

	dismissAlertClickHandler() {
		this.alertWrapper.parentElement.classList.add('u-hidden');
	}

	cancelButtonClickHandler() {
		this.confirmationModal.show();
	}

	earlyCancellationButtonClickHandler() {
		this.earlyCancellationModal.show();
	}

	pushDataLayer(event, action) {
		if(!dataLayer) {
			return;
		}
		const defaultFavouriteData = {
			event: event,
			venue_id: this.venueId,
			venue_name: this.venueName,
			screen: 'booking_confirmation',
		};
		switch(event) {
			case 'favourite_click':
			case 'favourite_login_prompt_shown':
			case 'favourite_limit_reached_prompt_shown':
				dataLayer.push({
					...defaultFavouriteData,
				});
				break;
			
			case 'favourite_added':
			case 'favourite_removed':
				dataLayer.push({
					...defaultFavouriteData,
					favourite_status: action,
				});
				break;		
		}
	}
}

const globalCourtBookingConfirmation = new CourtBookingConfirmation();
export default globalCourtBookingConfirmation;
